import { ArrowRight } from 'lucide-react';
import LearnMoreFilterDemo from '@/assets/images/filter/LearnMoreFilterDemo.png';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function LearnMoreCard() {
  const navigate = useNavigate();

  return (
    <div className="relative w-full rounded-2xl min-h-[400px] flex items-center justify-center pl-10 pt-6">
      <div className="mx-auto grid max-w-6xl gap-8 lg:grid-cols-2 lg:gap-12">
        <div className="w-[475px] flex flex-col justify-center space-y-6">
          <h1 className="text-[44px] tracking-tight leading-[44px]">Transform Your Music with StyleFilters™</h1>
          <p className="max-w-xl text-muted-foreground text-[#71717A] text-[18px] leading-[24px] tracking-[-0.32px]">
            <span className="text-[#71717A]">StyleFilters™ are a groundbreaking patented innovation in music creation, </span>
            <span className="text-[#111112]">
              allowing users to infuse AI-generated music with the distinct styles of their favorite artists and producers
            </span>
            <span className="text-[#71717A]">
              , instantly transforming simple prompts into compositions that resonate with personality and depth.
            </span>
          </p>
          {/* <div>
            <a
              onClick={() => {
                navigate('/marketplace/artist/imogen-heap');
              }}
              className="cursor-pointer group inline-flex items-center gap-2 text-lg font-medium text-[#FF5B27] hover:text-orange-600 tracking-[-0.23px]"
            >
              <Button
                variant="ghost"
                size="icon"
                rounded
                className="h-8 w-8 bg-[#FF5B2733] text-jen-orange group-hover:bg-jen-orange-100 group-hover:text-white relative z-10"
              >
                <ArrowRight className="h-4 w-4 transition-transform" />
              </Button>
              Learn More
            </a>
          </div> */}
        </div>
        <div className="flex items-center justify-center lg:justify-end mt-28">
          <div className="absolute h-full w-[300px]">
            <img
              src={LearnMoreFilterDemo}
              alt="StyleFilters interface showing music filter controls"
              className="h-full w-full object-contain [image-rendering:-webkit-optimize-contrast] [backface-visibility:hidden] scale-[1.2]"
              style={{
                imageRendering: '-webkit-optimize-contrast',
                WebkitBackfaceVisibility: 'hidden',
              }}
              loading="eager"
            />
          </div>
          <div className="absolute -bottom-8 -left-8 -right-8 -top-8 -z-10 rounded-[32px] bg-gradient-to-br from-orange-100 via-rose-50 to-violet-50 opacity-50 blur-2xl" />
        </div>
      </div>
    </div>
  );
}
